import { classes } from "@theme/helpers";
import { HTMLShopifySectionElement } from "@theme/html-custom-element";

class FeaturedProductCard extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.thumbnailClicked) {
      this.on("click", this, this.handleClickEvent.bind(this));

      this.on(
        "mouseenter",
        this.refs.thumbnailClicked,
        this.handleHoverEvent.bind(this),
      );
      this.on(
        "mouseleave",
        this.refs.thumbnailClicked,
        this.handleLeaveEvent.bind(this),
      );
      this.on("click", this.refs.closeButton, this.handleCloseEvent.bind(this));
    }
  }

  handleClickEvent(event) {
    this.refs.thumbnailClicked.classList.add(classes.active);
    this.refs.callToAction.classList.remove(classes.active);
    this.refs.subtitle.classList.add(classes.active);
    this.refs.title.classList.remove(classes.active);
    this.refs.secondTitle.classList.add(classes.active);
  }

  handleHoverEvent(event) {
    this.refs.thumbnailHover.classList.add(classes.active);
  }

  handleLeaveEvent(event) {
    this.refs.thumbnailHover.classList.remove(classes.active);
  }

  handleCloseEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    this.refs.thumbnailClicked.classList.remove(classes.active);
    this.refs.callToAction.classList.add(classes.active);
    this.refs.subtitle.classList.remove(classes.active);
    this.refs.title.classList.add(classes.active);
    this.refs.secondTitle.classList.remove(classes.active);
  }
}

if (!customElements.get("featured-card"))
  customElements.define("featured-card", FeaturedProductCard);
